






























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IProject, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'project',
  }),
  mixins: [paginationMixin],
})
export default class ProjectList extends Vue {
  @Action('deleteEntities', { namespace: 'project' })
  deleteEntities: () => void;
  @Action('getEntities', { namespace: 'project' }) getEntities: () => void;
  @Action('updateEntity', { namespace: 'project' }) updateEntity: any;
  @Getter('entitiesSlice', { namespace: 'project' })
  entitiesSlice: IProject[];
  @State('pageParams', { namespace: 'project' }) pageParams: IPageParams;
  selected = [];
  interval = null;
  headers = [
    { text: 'Название', value: 'name' },
    { text: 'Ссылка', value: 'link' },
    { text: 'Статус', value: 'project_status', sortable: false },
  ];
  modalPatch = {};
  setModalPatchField(field: string, value: any) {
    Vue.set(this.modalPatch, field, value);
  }
  updateModalEntity() {
    this.updateEntity(this.modalPatch);
  }
  created() {
    this.getEntities();
  }
}
